import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { unregister } from './registerServiceWorker';
import { Provider } from 'react-redux';
import { Amplify } from 'aws-amplify';
import CacheBuster from 'react-cache-buster';
import { environment } from './environments/environment';
import { Apis } from './constants';
import store from './state/store';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';
import './index.css';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.userPoolId,
      userPoolClientId: environment.userPoolWebClientId,
      identityPoolId: environment.identityPoolId,
    },
  },
  API: {
    REST: {
      [Apis.CORE]: {
        endpoint: environment.coreApiUrl,
        region: environment.awsRegion,
      },
      [Apis.ANALYTICS]: {
        endpoint: environment.analyticsApiUrl,
        region: environment.awsRegion,
      },
    },
  },
});

const isProduction = process.env.NODE_ENV === 'production';

const root = createRoot(document.getElementById('root') as HTMLElement);

const queryClient = new QueryClient();

root.render(
  <Provider store={store}>
    <GoogleOAuthProvider clientId={environment.youtubeClientId || ''}>
      <GoogleReCaptchaProvider reCaptchaKey={environment.googleCaptchaSiteKey} useEnterprise>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <CacheBuster currentVersion={process.env.REACT_APP_VERSION} isEnabled={isProduction} isVerboseMode={false}>
              <App />
            </CacheBuster>
          </BrowserRouter>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </GoogleReCaptchaProvider>
    </GoogleOAuthProvider>
  </Provider>,
);

// registerServiceWorker();
unregister();
